import PropTypes from 'prop-types'
import React from 'react'

import { TextStyled, Wrapper, Border } from './styles'

const FaqBlockTab = props => {
  const { title, isActive, tabRef, onTabClick, colorTheme, isLast } = props
  const handleClick = () => {
    if (onTabClick) {
      onTabClick()
    }
  }

  return (
    <Wrapper {...{ isActive, colorTheme }} ref={tabRef} onClick={handleClick}>
      <TextStyled
        className="py-3"
        dangerouslySetInnerHTML={{ __html: title }}
      />

      {!isLast && <Border />}
    </Wrapper>
  )
}

FaqBlockTab.propTypes = {
  isActive: PropTypes.bool.isRequired,
  title: PropTypes.string.isRequired,
  colorTheme: PropTypes.string.isRequired,
  tabRef: PropTypes.object,
  onTabClick: PropTypes.func,
  isLast: PropTypes.bool,
}

FaqBlockTab.defaultProps = {
  tabRef: null,
  isLast: false,
}

export default FaqBlockTab
